import { useEffect, useState } from "react";
import {
  Alert,
  Box,
  Button,
  Paper,
  Stack,
  TextField,
  Typography
} from "@mui/material";
import { apiRequest } from "../utils/http";

const initialForm = {
  heroTitle: "",
  heroSubtitle: "",
  story: "",
  mission: "",
  vision: "",
  phone: "",
  email: "",
  address: ""
};

const AboutPage = () => {
  const [form, setForm] = useState(initialForm);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [isSaving, setIsSaving] = useState(false);

  useEffect(() => {
    apiRequest("/api/about")
      .then((response) => setForm({ ...initialForm, ...(response?.data || {}) }))
      .catch((loadError) => setError(loadError.message || "Unable to load about content."));
  }, []);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setForm((current) => ({ ...current, [name]: value }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError("");
    setSuccess("");

    try {
      setIsSaving(true);
      const response = await apiRequest("/api/about", {
        method: "PUT",
        body: JSON.stringify(form)
      });
      setSuccess(response?.message || "About content updated.");
    } catch (saveError) {
      setError(saveError.message || "Unable to update about content.");
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <Stack spacing={3}>
      <Box>
        <Typography variant="h4" sx={{ mb: 1 }}>About Content</Typography>
        <Typography sx={{ color: "text.secondary" }}>
          Keep the storefront story, contact details, and brand messaging current.
        </Typography>
      </Box>

      {error && <Alert severity="error">{error}</Alert>}
      {success && <Alert severity="success">{success}</Alert>}

      <Paper sx={{ p: { xs: 2.5, md: 3 } }}>
        <Box component="form" onSubmit={handleSubmit}>
          <Stack spacing={2.5}>
            <TextField label="Hero Title" name="heroTitle" value={form.heroTitle} onChange={handleChange} fullWidth />
            <TextField
              label="Hero Subtitle"
              name="heroSubtitle"
              value={form.heroSubtitle}
              onChange={handleChange}
              fullWidth
              multiline
              minRows={2}
            />
            <TextField label="Story" name="story" value={form.story} onChange={handleChange} fullWidth multiline minRows={4} />
            <TextField label="Mission" name="mission" value={form.mission} onChange={handleChange} fullWidth multiline minRows={3} />
            <TextField label="Vision" name="vision" value={form.vision} onChange={handleChange} fullWidth multiline minRows={3} />
            <TextField label="Phone" name="phone" value={form.phone} onChange={handleChange} fullWidth />
            <TextField label="Email" name="email" value={form.email} onChange={handleChange} fullWidth />
            <TextField label="Address" name="address" value={form.address} onChange={handleChange} fullWidth multiline minRows={2} />
            <Button type="submit" variant="contained" disabled={isSaving} sx={{ width: { xs: "100%", sm: "fit-content" } }}>
              {isSaving ? "Saving..." : "Save About Content"}
            </Button>
          </Stack>
        </Box>
      </Paper>
    </Stack>
  );
};

export default AboutPage;
